/* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
.ux-iws-meta-navigation-toolbox {
    display: block;
    padding-top: 15px;
    max-width: 100%;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        padding-top: 35px;
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        max-height: 160px;
        height: 160px;
        overflow: hidden;
    }

    &__inner {
        padding: 25px 30px 5px;
        width: 100%;
        background: hsl(228, 19%, 95%);
        display: flex;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            background: $color-blue-6;
            height: 100%;
            padding: 28px 30px 0;
            display: flex;
        }

        @media only screen and (min-width: $desktop-l) {
            padding-left: 170px;
            padding-right: 170px;
        }

        .ux-iws-header--100 & {
            @media only screen and (min-width: $desktop-l) {
                padding-left: 30px;
                padding-right: 30px;
            }

            @media only screen and (min-width: 1700px) {
                padding-left: 170px;
                padding-right: 170px;
            }
        }
    }

    ux-loader[variant="spinner"] {
        margin-top: 5px;
    }

    .block-marginal {
        margin: 0 !important;
    }

    .block-marginal-serviceIcons .block-content {
        display: flex;
        flex-direction: column;

        @media only screen and (min-width: $tablet) {
            flex-wrap: wrap;
            flex-direction: row;

            > .ux-iws-teaser-sidebar-icon {
                width: 50%;
            }
        }

        @media only screen and (min-width: $desktop-s-navigation-100) {
            flex-direction: row;

            > .ux-iws-teaser-sidebar-icon {
                margin-right: 80px;
                width: auto;
            }
        }
    }

    .ux-iws-teaser-sidebar-icon {
        margin-bottom: 0;
        padding-top: 0;
        padding-bottom: 25px;
        min-height: 54px;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            min-height: 44px;
            padding-bottom: 15px;
        }

        [slot="link"],
        [slot="title"] {
            color: $color-black;
            text-decoration: none;
        }
    }

    .ux-iws-teaser-sidebar-icon__text-content {
        .ux-text-link {
            display: none;
        }
    }

    .ux-iws-teaser-sidebar-icon__wrapper {
        margin-bottom: 0;

        > ux-icon {
            font-size: 29px;
            margin-right: 15px;
        }
    }

    .marginal-headline {
        border: 0;
        margin-bottom: 14px;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            margin-bottom: 11px;
        }

        span {
            @include font(bold);
            line-height: 1.6;
            font-size: $size-text-small;
            margin: 0;
            text-transform: uppercase;
        }
    }

    &__profile {
        display: flex;
    }

    &__profile-image {
        width: 82px;
        height: 109px;
        margin-right: 20px;
    }

    &__profile-info {
        @include font(light);
        font-size: $size-text-small;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }

    &__profile-contact {
        a {
            @include font(normal);
            font-size: 20px;
        }
    }

    &__profile-name {
        font-size: $size-text-normal;
    }

    &__searchbox {
        form {
            display: flex;
        }

        input[type="text"] {
            margin-right: 30px;
        }
    }

    .block-marginal-serviceIcons {
        display: block;
    }

    &__link,
    .block-marginal-serviceIcon-item {
        display: flex;
        align-items: center;

        &:last-child {
            margin-bottom: 0;
        }

        .serviceIcon-icon {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 23px;
            width: 23px;
            margin: 0;
            margin-right: 15px;
        }

        @media only screen and (min-width: $desktop-s-navigation-100) {
            .serviceIcon-inner {
                width: 100%;
            }
        }

        > a,
        .serviceIcon-inner .text-medium {
            text-decoration: none;
            color: $color-black;
            font-size: $size-text-normal;
        }
    }
}

/* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
